import {
  ALL_LOCATIONS_LABEL,
  canonicalCityLabel,
  isAllLocationsSelection,
} from './cityUtils';

const STORAGE_KEY = 'bfp_selected_city';
/** Legacy default; new sessions use all locations so every stay is discoverable. */
export const DEFAULT_NAV_CITY = 'Mumbai';

export function getStoredCity() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (!v || !String(v).trim()) return ALL_LOCATIONS_LABEL;
    if (isAllLocationsSelection(v)) return ALL_LOCATIONS_LABEL;
    return canonicalCityLabel(v);
  } catch {
    return ALL_LOCATIONS_LABEL;
  }
}

export function setStoredCity(city) {
  const trimmed = city && String(city).trim();
  const next = !trimmed || isAllLocationsSelection(trimmed)
    ? ALL_LOCATIONS_LABEL
    : canonicalCityLabel(trimmed);
  try {
    localStorage.setItem(STORAGE_KEY, next);
  } catch {
    /* ignore */
  }
  window.dispatchEvent(new CustomEvent('bfp:city-changed', { detail: { city: next } }));
}
